import React from "react"
import { SelectMenu } from '../forms'
import { Field  } from "redux-form"
import { connect } from "react-redux"
import { Errors } from "../../api/util"
import { EXISTING_QF_CUSTOMER_ROLE , GROUND_HANDLER_ROLE} from "../../api/constants";

let DomesticCustomerSelectMenu = props => {

    return <Field name="customer" onChange={(e,n,p)=>{ props.dispatch(Errors.clear())}} options={[
        {value: EXISTING_QF_CUSTOMER_ROLE, label: 'Current QF customer', type: "domestic"},
        {value: GROUND_HANDLER_ROLE, label: 'Ground handler', type: "domestic"},
        {value: 'new-customer', label: 'New customer', type: "domestic"},
    ]} title="Are you registering as a..." component={SelectMenu} />
};



DomesticCustomerSelectMenu = connect( state => {

    return {


    }

} )(DomesticCustomerSelectMenu);

export {
    DomesticCustomerSelectMenu,
}